module.exports = __webpack_public_path__ + "img/logo.676d916e.png";